module.exports = __webpack_public_path__ + "static/images/styles/images/button-small/bsm-secondary-active-bg.0f5acd54.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/button-small/bsm-secondary-active-bg.png
// module id = 3603
// module chunks = 11